module.exports = __webpack_public_path__ + "static/media/Airbnb2.d97d73f5.png";